import { EntityIcon } from '..';
import { TProps } from '../types/TProps';

const profileSizeClassName =
  'h-[50px] w-[50px] bg-[var(--color-avatar-bg)] text-[26px] leading-[150%] text-[var(--color-on-surface)]';

export const EntityIconProfile = ({ className, sizeClassName, ...props }: TProps) => (
  <EntityIcon {...props} sizeClassName={sizeClassName ?? profileSizeClassName} className={className} />
);
